import { getUser } from 'auth/authenticate';
import React, {createContext} from 'react';

const UserContext = createContext();

export default UserContext;